import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  CircularProgress,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  Chip,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { Lock, Schedule, Visibility, VisibilityOff } from "@mui/icons-material";

const AddAccounts = () => {
  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [loading, setLoading] = useState(false);
  const [portalUrl, setPortalUrl] = useState("");
  const [apiHealthUrl, setapiHealthUrl] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [zone, setZone] = useState("");

  const [isWeekendRunEnabled, setIsWeekendRunEnabled] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsWeekendRunEnabled(event.target.checked);
  };

  const dayLabels = {
    1: "Sunday",
    2: "Monday",
    3: "Tuesday",
    4: "Wednesday",
    5: "Thursday",
    6: "Friday",
    7: "Saturday",
  };
  const [days, setDays] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL;
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  function generateCronExpressions(days, startTime, endTime) {
    /**
     * @param {string} time - Time in "HH:mm" format.
     * @returns {Object} - An object containing hours and minutes.
     */
    const parseTime = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      return { hours, minutes };
    };
    /**
     * @param {number} hours - Hours component of the time.
     * @param {number} minutes - Minutes component of the time.
     * @returns {Object} - An object containing adjusted hours and minutes.
     */
    const subtract30Minutes = (hours, minutes) => {
      const totalMinutes = hours * 60 + minutes - 30;
      const adjustedHours = Math.floor(((totalMinutes + 1440) % 1440) / 60);
      const adjustedMinutes = ((totalMinutes + 1440) % 1440) % 60;
      return { hours: adjustedHours, minutes: adjustedMinutes };
    };
    const { hours: startHour, minutes: startMinute } = parseTime(startTime);
    const { hours: endHour, minutes: endMinute } = parseTime(endTime);
    const { hours: halfHourBeforeHour, minutes: halfHourBeforeMinute } =
      subtract30Minutes(startHour, startMinute);
    const daysString = days.join(",");
    const filteredDays = days.filter((day) => day !== "1" && day !== "7");
    const filteredDaysString = filteredDays.join(",");
    const startCron = `${startMinute} ${startHour} ? * ${daysString} *`;
    let endCron;
    if (isWeekendRunEnabled) {
      endCron = `${endMinute} ${endHour} ? * ${daysString} *`;
    } else {
      endCron = `${endMinute} ${endHour} ? * ${filteredDaysString},1,7 *`;
    }
    const halfHourBeforeCron = `${halfHourBeforeMinute} ${halfHourBeforeHour} ? * ${daysString} *`;
    return {
      startCron,
      endCron,
      halfHourBeforeCron,
    };
  }

  const numberToDays = {
    1: "Sun",
    2: "Mon",
    3: "Tue",
    4: "Wed",
    5: "Thu",
    6: "Fri",
    7: "Sat",
  };

  const navigate = useNavigate();
  const accessToken = sessionStorage.getItem("accessToken");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(
        `${apiUrl}/accounts`,
        {
          AccountNo: accountNumber,
          AccountName: accountName,
          username: username,
          password: password,
          apiUrl: apiHealthUrl,
          portalUrl: portalUrl,
          // startTime: startTime,
          // endTime: endTime,
          // days: days,
          scheduledescription: `${days.map((i) => {
            return numberToDays[i];
          })} ${startTime} -${endTime}`,
          startecscronexpression: generateCronExpressions(
            days,
            startTime,
            endTime
          ).startCron,
          startrdscronexpression: generateCronExpressions(
            days,
            startTime,
            endTime
          ).halfHourBeforeCron,
          stopcronexpression: generateCronExpressions(days, startTime, endTime)
            .endCron,
          timezone: zone,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        }
      );
      navigate("/accounts");
    } catch (error) {
      console.error("Error adding account:", error);
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };
  let isAdmin = useSelector((state) => state.admin.value);
  return isAdmin ? (
    <Box
      sx={{
        marginLeft: "180px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 3,
        backgroundColor: "#EEEEEE",
        minHeight: "100vh",
      }}
    >
      <Typography
        variant="h4"
        component="h2"
        sx={{
          fontWeight: "bold",
          mb: 4,
          color: "#00ADB5",
          textAlign: "center",
          fontFamily: "Poppins",
        }}
      >
        Add New Account
      </Typography>
      <Paper
        elevation={1}
        sx={{
          backgroundColor: "#FFFFFF",
          p: 3,
          borderRadius: "8px",
          mb: 4,
          textAlign: "center",
        }}
      >
        <Typography sx={{ color: "#222831", fontFamily: "Poppins" }}>
          <strong>Tip:</strong> To find the account number, visit the Visteon
          AWS portal link. Copy the name and account number you want to add
          here.
        </Typography>
      </Paper>
      <form
        style={{
          maxWidth: "800px",
          width: "100%",
          backgroundColor: "#FFFFFF",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
        onSubmit={handleSubmit}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 4, // Added spacing between form sections
          }}
        >
          <Box sx={{ flex: 1, minWidth: "300px" }}>
            <TextField
              label="Account Name"
              variant="outlined"
              type="text"
              value={accountName}
              onChange={(e) => setAccountName(e.target.value)}
              required
              fullWidth
              sx={{ mb: 3, fontFamily: "Poppins" }}
            />
            <TextField
              label="Account Number"
              variant="outlined"
              type="number"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              required
              fullWidth
              sx={{ mb: 3, fontFamily: "Poppins" }}
            />
            <TextField
              label="Portal URL"
              variant="outlined"
              value={portalUrl}
              onChange={(e) => setPortalUrl(e.target.value)}
              required
              fullWidth
              sx={{ mb: 3, fontFamily: "Poppins" }}
            />
            <TextField
              label="API URL"
              variant="outlined"
              value={apiHealthUrl}
              type="text"
              onChange={(e) => setapiHealthUrl(e.target.value)}
              required
              fullWidth
              sx={{ mb: 3, fontFamily: "Poppins" }}
            />
            <TextField
              label="Username"
              type="text"
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              fullWidth
              sx={{ mb: 3, fontFamily: "Poppins" }}
            />
            <TextField
              label="Password"
              type={showPassword ? "text" : "password"}
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              fullWidth
              sx={{ mb: 3, fontFamily: "Poppins" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? (
                        <VisibilityOff fontSize="inherit" />
                      ) : (
                        <Visibility fontSize="inherit" />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box
            sx={{
              flex: 1,
              minWidth: "300px",
              // height: 460,
              p: 3,
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#FAFAFA",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: "1rem",
                fontWeight: "bold",
                color: "#222831",
                mb: 2,
              }}
            >
              Schedule Settings
            </Typography>
            <label style={{ fontFamily: "Poppins" }}>Select days</label>
            <Select
              multiple
              required
              value={days || []}
              onChange={(e) => setDays(e.target.value)}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={dayLabels[value]} />
                  ))}
                </Box>
              )}
              fullWidth
              sx={{ mb: 3 }}
            >
              <MenuItem value="2">Monday</MenuItem>
              <MenuItem value="3">Tuesday</MenuItem>
              <MenuItem value="4">Wednesday</MenuItem>
              <MenuItem value="5">Thursday</MenuItem>
              <MenuItem value="6">Friday</MenuItem>
              <MenuItem value="7">Saturday</MenuItem>
              <MenuItem value="1">Sunday</MenuItem>
            </Select>
            <FormControlLabel
              sx={{
                fontFamily: "Poppins",
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                },
              }}
              label="Servers stop on weekends. Override?"
              control={
                <Checkbox
                  checked={isWeekendRunEnabled}
                  onChange={handleCheckboxChange}
                />
              }
            />
            <br />
            <br />
            <label style={{ fontFamily: "Poppins" }}>Time Zone</label>
            <Select
              required
              value={zone}
              onChange={(e) => setZone(e.target.value)}
              renderValue={() => zone}
              fullWidth
            >
              <MenuItem value="Asia/Calcutta">Asia/Calcutta</MenuItem>
              <MenuItem value="Etc/GMT-4">Etc/GMT-4</MenuItem>
            </Select>
            <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
              <Box sx={{ flex: 1 }}>
                <label style={{ fontFamily: "Poppins" }}>Start Time</label>
                <TextField
                  required
                  type="time"
                  value={startTime || ""}
                  onChange={(e) => setStartTime(e.target.value)}
                  fullWidth
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <label style={{ fontFamily: "Poppins" }}>End Time</label>
                <TextField
                  required
                  type="time"
                  value={endTime || ""}
                  onChange={(e) => setEndTime(e.target.value)}
                  fullWidth
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: "#00ADB5",
              color: "#FFFFFF",
              fontFamily: "Poppins",
              "&:hover": { backgroundColor: "#007B7F" },
            }}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>
        </Box>
      </form>
    </Box>
  ) : (
    <Box sx={{ textAlign: "center", mt: 10 }}>
      <Typography
        variant="h5"
        sx={{ color: "red", fontWeight: "bold", fontFamily: "Poppins" }}
      >
        You are not authorized to view this page. Ask Admin to provide access.
      </Typography>
    </Box>
  );
};

export default AddAccounts;
